import { queryOptions } from '@tanstack/react-query';

import { tenantSettingsApi } from '@/shared/api/tenantSettings';

/**
 * `GET /tenant-settings/appearance` (`13` §6.5, `AM-173`): fetched once per session - a long
 * `staleTime`, since the tenant's color and support contact rarely change - and invalidated by the
 * admin form's own successful save (`14` §12, "se invalida al guardar, nunca solo por TTL"), never
 * by a shorter TTL. A tenant switch already clears the whole query cache (`forgetSession`), so this
 * key needs no tenant id of its own.
 */
export const appearanceQueryKey = ['tenantSettings', 'appearance'] as const;

export function appearanceQueryOptions() {
  return queryOptions({
    queryKey: appearanceQueryKey,
    queryFn: ({ signal }) => tenantSettingsApi.appearance(signal),
    staleTime: 30 * 60_000,
  });
}
